import { ref as S, defineComponent as g, inject as N, computed as l, onMounted as y, openBlock as o, createElementBlock as t, normalizeClass as b, createElementVNode as r, createVNode as d, unref as u, createCommentVNode as c, toDisplayString as f, TransitionGroup as w, withCtx as B, Fragment as O, renderList as $, createBlock as z, mergeProps as R } from "vue";
import { CloseIcon as F } from "@frontiers/brink-icons";
import { useTimeoutFn as G } from "@vueuse/core";
import { Button as P } from "./button.es.js";
import { FeedbackIcon as H } from "./feedbackIcon.es.js";
import V from "gsap";
import './assets/index36.css';const U = 40, X = 120, v = {
  SHORT: 5e3,
  LONG: 7e3
}, n = S([]), ce = () => {
  n.value = [];
}, j = (i) => {
  n.value = n.value.filter((a) => a.id !== i);
}, re = (i) => {
  const a = `snackbar-${n.value.length}`;
  n.value = [...n.value, { ...i, id: a }];
}, W = ["aria-live", "aria-label"], q = /* @__PURE__ */ r("div", { class: "Snackbar__left-bar" }, null, -1), J = { class: "Snackbar__wrapper" }, K = {
  key: 0,
  class: "Snackbar__icon"
}, Q = { class: "Snackbar__content" }, Y = {
  key: 1,
  class: "Snackbar__additionalText"
}, Z = {
  key: 2,
  class: "Snackbar__action"
}, x = /* @__PURE__ */ g({
  __name: "Snackbar",
  props: {
    autoDismiss: { type: Boolean, default: !0 },
    id: {},
    message: {},
    additionalText: { default: void 0 },
    type: { default: "neutral" },
    actionLabel: { default: void 0 },
    onActionClick: { type: Function, default: void 0 },
    icon: { default: void 0 },
    iconLocation: { default: void 0 },
    showCloseIcon: { type: Boolean, default: !1 },
    isLoadingAction: { type: Boolean, default: !1 },
    isDisabledAction: { type: Boolean, default: !1 }
  },
  setup(i) {
    const a = i, _ = N("isDesktopApp"), s = S(null), p = l(
      () => !(a.message.length >= U || a.additionalText)
    ), h = l(
      () => a.message.length > X || a.additionalText
    ), T = l(
      () => !!a.actionLabel && typeof a.onActionClick == "function"
    ), C = l(() => _.value === void 0 || _.value ? "lg" : "md"), D = l(() => h.value ? v.LONG : v.SHORT), { start: k, stop: L } = G(() => {
      a.autoDismiss && m();
    }, D), A = () => {
      a.autoDismiss && L();
    }, M = () => {
      a.autoDismiss && k();
    }, I = () => {
      V.to(s.value, {
        duration: 0.3,
        opacity: 0,
        yPercent: 100,
        onComplete: () => {
          var e;
          (e = s.value) == null || e.remove();
        }
      });
    }, m = () => {
      n.value.length === 0 ? I() : j(a.id);
    }, E = () => {
      var e;
      (e = a.onActionClick) == null || e.call(a), m();
    };
    return y(() => {
      a.autoDismiss && k();
    }), (e, ae) => (o(), t("div", {
      ref_key: "snackbarEl",
      ref: s,
      "aria-live": e.autoDismiss ? "assertive" : "polite",
      "aria-label": `${e.message}. ${e.additionalText ?? ""}`,
      "data-cy": "Snackbar",
      class: b(["Snackbar", [
        e.type ? `Snackbar--${e.type}` : "",
        {
          "Snackbar--line": p.value
        }
      ]]),
      onMouseleave: M,
      onMouseenter: A
    }, [
      q,
      r("div", J, [
        e.type !== "neutral" ? (o(), t("div", K, [
          d(u(H), {
            type: e.type,
            size: C.value
          }, null, 8, ["type", "size"])
        ])) : c("", !0),
        r("div", Q, [
          r("p", {
            class: b(["Snackbar__message", {
              "Snackbar__message--with-max-width": !p.value && e.showCloseIcon,
              "Snackbar__message--with-icon": e.type
            }])
          }, f(e.message), 3),
          e.showCloseIcon ? (o(), t("button", {
            key: 0,
            "aria-label": "Close",
            class: "Snackbar__close",
            onClick: m
          }, [
            d(u(F), { size: "md" })
          ])) : c("", !0),
          e.additionalText ? (o(), t("div", Y, f(e.additionalText), 1)) : c("", !0),
          T.value ? (o(), t("div", Z, [
            d(u(P), {
              text: e.actionLabel,
              color: "White",
              type: "Outline",
              size: "Medium",
              icon: e.icon,
              "icon-location": e.iconLocation,
              "is-loading": e.isLoadingAction,
              "is-disabled": e.isDisabledAction,
              onClick: E
            }, null, 8, ["text", "icon", "icon-location", "is-loading", "is-disabled"])
          ])) : c("", !0)
        ])
      ])
    ], 42, W));
  }
});
const ee = { class: "SnackbarManager" }, de = /* @__PURE__ */ g({
  __name: "SnackbarManager",
  setup(i) {
    return y(() => {
      n.value = [];
    }), (a, _) => (o(), t("div", ee, [
      d(w, { name: "SnackbarTransition" }, {
        default: B(() => [
          (o(!0), t(O, null, $(u(n), (s) => (o(), z(x, R(s, {
            key: s.id
          }), null, 16))), 128))
        ]),
        _: 1
      })
    ]));
  }
});
export {
  x as Snackbar,
  de as SnackbarManager,
  ce as clearAllSnackbarNotification,
  re as createSnackbarNotification
};
